import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import Button from '@atlaskit/button';
import FocusRing from '@atlaskit/focus-ring';
import { N20, N30A } from '@atlaskit/theme/colors';
import { ConditionalFadeOut } from '../conditional-fade-out';

// Keep padding/margins aligned with ItemContainer
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var BackgroundFadeOut = styled(ConditionalFadeOut)({
  marginLeft: "var(--ds-space-negative-100, -8px)",
  marginRight: "var(--ds-space-negative-100, -8px)",
  marginBottom: "var(--ds-space-050, 4px)",
  borderRadius: '3px'
});
export var ItemContainer = function ItemContainer(props) {
  return /*#__PURE__*/React.createElement(FocusRing, null, /*#__PURE__*/React.createElement(ItemContainerArticle, props));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var ItemContainerArticle = styled.article({
  position: 'relative',
  padding: "var(--ds-space-100, 8px)",
  '&:hover': {
    backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat(N20, ")")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&:hover .notification-list__unread-indicator-wrapper': {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: "var(--ds-border, ".concat(N30A, ")")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&:hover .notification-list__item-entity-link': {
    textDecorationLine: 'underline'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&:hover .notification-list__open-in-new-tab-button': {
    visibility: 'visible',
    zIndex: 1
  }
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (props) {
  return props.backgroundOnActive && "\n    &:active {\n      background-color: ".concat("var(--ds-background-neutral-subtle-pressed, rgba(179,212,255,0.6))", ";\n    }");
}, {
  borderRadius: '3px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var MainAction = styled.a({
  position: 'absolute',
  left: 0,
  top: 0,
  bottom: 0,
  right: 0
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var NotificationContainer = styled.div({
  display: 'flex',
  width: '100%',
  zIndex: 1,
  pointerEvents: 'all'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SummaryContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var EnableMouseEventsProfileWrapper = styled.div({
  position: 'relative',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '& *': {
    pointerEvents: 'all',
    zIndex: 1
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var EnableMouseEventsDocumentWrapper = styled.div({
  position: 'relative',
  width: '100%',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '& *': {
    pointerEvents: 'all',
    zIndex: 1
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var EnableMouseEventsReactReplyWrapper = styled.div({
  position: 'relative',
  width: '100%'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var DocumentWrapper = styled.div({
  display: 'flex'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var DocumentLeftSpacing = styled.div({
  width: '52px',
  height: '100%',
  flexShrink: 0
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var FullWidth = styled.div({
  width: '100%'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var FlexRow = styled.div({
  display: 'flex'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var InboxReadStateIndicatorContainer = styled.div({
  margin: "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-100, 8px)", " ", "var(--ds-space-100, 8px)", " 0")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var NotificationButton = styled(Button)({
  pointerEvents: 'all',
  margin: "var(--ds-space-050, 4px)".concat(" 0 ", "var(--ds-space-050, 4px)", " 0")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var NotificationButtonDivider = styled.span({
  margin: "0 ".concat("var(--ds-space-050, 4px)", " 0 ", "var(--ds-space-050, 4px)")
});